/**
 * @param {Number} number Number to be formatted
 * @param {Object} options Options for formatting the number to be displayed
 * @param {Number} options.decimals Cents to display
 * @param {String} options.thousandDivisor Defines separator of the thousands piece
 * @param {String} options.decimalsDivisor Defines separator of the decimals piece
 * @param {Boolean} options.forceDecimals Defines if decimals should be forced
 * @returns {string}
 */
export default function formatNumber(
  number, {
    decimals = 0,
    thousandDivisor = '.',
    decimalsDivisor = ',',
    forceDecimals = true,
  } = {},
) {
  const fractionToWhole = Math.pow(10, decimals); // eslint-disable-line
  const wholeNumberString =
    String(Math.round(fractionToWhole * Number(number)) / fractionToWhole);
  const hasDecimals = wholeNumberString.indexOf('.') === -1;
  const separatorIndex =
    hasDecimals ? wholeNumberString.length : wholeNumberString.indexOf('.');
  let returnString =
    decimals > 0 ?
    decimalsDivisor + wholeNumberString.substr(separatorIndex + 1) :
    '';

  if (forceDecimals) {
    for (
      let j = 0;
      j <= decimals -
        (wholeNumberString.length -
        (hasDecimals ? separatorIndex - 1 : separatorIndex));
      j += 1) {
      returnString += '0';
    }
  }

  let index = 0;
  const length =
    wholeNumberString.substr(0, 1) === '-' ?
    separatorIndex - 1 :
    separatorIndex;

  while (index + 3 < length) {
    returnString =
      thousandDivisor +
      wholeNumberString.substr(separatorIndex - (index += 3), 3) +
      returnString;
  }

  returnString =
    wholeNumberString.substr(0, separatorIndex - index) + returnString;

  return String(returnString);
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/helpers/formatters/formatNumber.js